import { useEffect } from 'react';
import { useAuthStore } from './useAuthStore';

/** Toggles body flag so Atlassian support widget stays hidden until signed in. */
export function AssistantAuthBodyFlag() {
  const status = useAuthStore((s) => s.status);

  useEffect(() => {
    if (status === 'authenticated') {
      document.body.setAttribute('data-assistant-auth', 'true');
    } else {
      document.body.removeAttribute('data-assistant-auth');
    }

    return () => {
      document.body.removeAttribute('data-assistant-auth');
    };
  }, [status]);

  return null;
}
